module.exports = __webpack_public_path__ + "static/media/test4_4.6fc08b06.png";